import OptionCancelPartSearchClaim from "./options/optionCancelPartSearchClaim";
import OptionEditPartSearchClaim from "./options/optionEditPartSearchClaim";
import OptionImagesPartSearchClaim from "./options/optionImagesPartSearchClaim";
import OptionReassignPartSearchClaim from "./options/optionReassignPartSearchClaim";
import OptionReopenPartSearchClaim from "./options/optionReopenPartSearchClaim";
import OptionReturnPartSearchClaim from "./options/optionReturnPartSearchClaim";
import ThreeDotsPartSearchClaim from "./threeDotsPartSearchClaim";

const ThreeDotsPartSearchClaimComponents = {
  Root: ThreeDotsPartSearchClaim,
  OptionReassign: OptionReassignPartSearchClaim,
  OptionEditPart: OptionEditPartSearchClaim,
  OptionImagesPart: OptionImagesPartSearchClaim,
  OptionReopenPart: OptionReopenPartSearchClaim,
  OptionReturn: OptionReturnPartSearchClaim,
  OptionCancel: OptionCancelPartSearchClaim,
};

export type ThreeDotsPartSearchClaimComponentsKeys = keyof typeof ThreeDotsPartSearchClaimComponents;

export default ThreeDotsPartSearchClaimComponents;